module.exports = __webpack_public_path__ + "static/media/Daniel.dded0111.JPG";